import { Dropdown, Space } from 'antd'
import React from 'react'
import { BiChevronDown } from 'react-icons/bi'


const AvtarDropDown = ({profile , items}) => {
  return (
    <div>
         <Dropdown
            menu={{
              items,
            }}
            trigger={['click']}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
              <img  src={profile}
                    className="me-1"
                    alt="alternate"
                    style={{ height: "36px", borderRadius: "50%" }}
                  />
               <span className='fs-5'> 
               <BiChevronDown />
                </span> 
              </Space>
            </a>
        </Dropdown>
        
    </div>
  )
}

export default AvtarDropDown